(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cactus-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cc-cols-carousel').forEach(function (wrap) {
  var track = wrap.querySelector('.cc-cols-track');
  if (!track) return;
  wrap.querySelectorAll('.cc-cols-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      track.scrollBy({ left: parseInt(btn.dataset.dir, 10) * track.clientWidth * 0.85, behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cactus-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var overlay = document.querySelector('.cc-pop-overlay');
  if(!overlay) return;
  var once = overlay.dataset.once === 'true';
  var key = 'cc_pop_' + (overlay.dataset.key || 'promo');
  var seen = false;
  if(once){ try{ seen = sessionStorage.getItem(key) === '1'; }catch(e){} }
  function open(){
    overlay.classList.add('is-open');
    if(once){ try{ sessionStorage.setItem(key,'1'); }catch(e){} }
  }
  function close(){ overlay.classList.remove('is-open'); }
  if(!seen){ setTimeout(open, 700); }
  overlay.querySelector('.cc-pop__close').addEventListener('click', close);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
